import React, { useMemo } from "react";
import { PickerList } from "@v2/components/controls/PickerList/PickerList";
import { DataField } from "shared/providers/types";

interface FieldPickerProps {
  items: DataField[];
  selectedFieldNames: string[];
  onChange: (fieldNames: string[]) => void;
  disabled?: boolean;
}

export const FieldPicker: React.FC<FieldPickerProps> = (props) => {
  const { items, selectedFieldNames, onChange, disabled } = props;

  const sortedItems = useMemo(() =>
      [...items]
        .sort((a, b) => a.label.localeCompare(b.label))
        .map(field => ({
          id: field.name,
          label: field.label,
        })),
    [items]);

  const popularIds = useMemo(() =>
      items
        .filter((item) => item.popular)
        .sort((a, b) => a.label.localeCompare(b.label))
        .map((item) => item.name),
    [items]
  );

  return (
    <PickerList
      items={sortedItems}
      selectedIds={selectedFieldNames}
      onSelectedIdsChange={onChange}
      idGroups={popularIds.length > 0
        ? [
          { label: 'Popular fields', ids: popularIds },
          { label: 'All fields', ids: sortedItems.map(item => item.id) },
        ]
        : []
      }
      maxHeight={350}
      disabled={disabled}
      searchTitle='Select fields'
    />
  )
}
